import React from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title
} from "chart.js";
import { Doughnut } from "react-chartjs-2";

// Register chart.js modules
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DoughnutChart = ({dashboardData}) => {

  const totalRevenue = dashboardData?.totalRevenue || 0;
  const pendingRevenue = dashboardData?.totalPendingRevenue || 0;

  // Chart data
  const data = {
    labels: ["Total Revenue", "Pending Revenue"],
    datasets: [
      {
        label: "Earings",
        data: [totalRevenue, pendingRevenue],
        backgroundColor: [
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: "Total Earnings" },
    },
  };

  return <Doughnut data={data} options={options} />;
};

export default DoughnutChart;
